var $ = require("./lib/qsa");
var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");
const Handlebars = require("handlebars");

// Could accommodate more but would need the stub html in index.html
// var statusLabels = ['running', 'considering', 'dropout', 'notrunning']
var statusLabels = ['running', 'dropout', 'notrunning']
var pymChild = null;

function scrollParentTo(e) {
  // parentlink is explicitly set server side in index.html
  // console.log('scrollParentTo: ' + e.currentTarget.parentlink);
  pymChild.scrollParentTo(e.currentTarget.parentlink);
}

function attachParentScrollers() {
  var cards = document.getElementsByClassName("data");
  Array.from(cards).forEach((card) => {
    card.addEventListener('click', scrollParentTo, false);  
  })
}

function build_page_from_data(json_data) {
  var template = Handlebars.compile(document.getElementById("candidate-template").innerHTML);
  var candidates = json_data['data'];
  
  // compile recent updates section
  var updates = json_data['updates'];
  updates.slice(0, 3).forEach((update) => {
    var updateEl = document.createElement('li');
    updateEl.innerHTML = `<span class="date">${update.date}:</span> ${update.text}`
    document.getElementById("updates-list").appendChild(updateEl);
  });
  
  statusLabels.forEach((label ) => {

    candidates.forEach((candidate) => {
      if (candidate['category'].trim() == label) {
        var context = candidate;
        context['label'] = label;
        var htmlToAdd = template(context); 
        var divToAppendID = "candidates-" + label;
        var newDiv = document.createElement('div'); // a node
        newDiv.classList.add("data");
        newDiv.classList.add(label)
        newDiv.id = "bio-" + candidate['name_slug'];
        newDiv.parentlink = candidate['name_slug'];
        newDiv.innerHTML = htmlToAdd;
        document.getElementById(divToAppendID).appendChild(newDiv);
      }
    });
  });
  attachParentScrollers();


  pym.then(child => {
      pymChild = child;
      sendHeight();
      window.addEventListener("resize", () => pymChild.sendHeight());
      setTimeout(() => {sendHeight()}, 400);
    });


}

function renderFromJSON() {
  fetch('https://apps.npr.org/dailygraphics/data/sheets/pres-candidate-tracker-20230220.json')
  .then((response) => response.json())
  .then((data) => {
    // console.log("Got json data");
    // console.log(data);
    build_page_from_data(data);
  })
  .catch(console.error);
}

function sendHeight() {
    // console.log("sendheight");
    pymChild.sendHeight();
}

// But don't send the window height to the parent iframe till assets are loaded
var onWindowLoaded = function() {

    renderFromJSON();

}

// wait for images to load
window.onload = onWindowLoaded;